/* Naar kupon merkezi (27 Eki 2026). Bölüm: sections/naar-kupon-merkezi.liquid, mantık: snippets/naar-kupon-bilet.liquid.
   Kuponlar admin'deki "Kupon Merkezi kuponu" kayıtlarından gelir (tutar, asgari sepet, adet, başlangıç/bitiş tarih-saati).
   - Saat sunucudan gelir (data-simdi); cihaz saati yanlış olsa da sayaç doğru çalışır.
   - Kod sayfa kaynağında YOKTUR. "Kuponu Al" ile /cart?view=kupon-kodu çağrılır; yalnızca kupon AÇIKKEN kod döner.
   - Geri sayım sıfırlanınca durumlar uç noktadan yenilenir (sayfa yenilemek gerekmez).
   - Önizleme (yayında olmayan tema): ?kupon_demo=acik | bekliyor | tukendi | bitti ile durumlar denenir.
   - 2 Kas 2026: ürün sayfası şeridi (snippets/naar-kupon-urun.liquid) de bu öğeyi kullanır. Orada
     data-uygula-yonlen verilir: düğme yazıları kısa ("Yakında") ve alınan kod arka planda sepete uygulanır
     (/discount/KOD), müşteri sayfadan ayrılmaz. */
(function () {
  if (customElements.get('naar-kupon-merkezi')) return;

  var pad = function (n) { return (n < 10 ? '0' : '') + n; };

  function sureYaz(sn) {
    sn = Math.max(0, Math.floor(sn));
    var g = Math.floor(sn / 86400), s = Math.floor((sn % 86400) / 3600), d = Math.floor((sn % 3600) / 60), k = sn % 60;
    return (g > 0 ? g + ' gün ' : '') + pad(s) + ':' + pad(d) + ':' + pad(k);
  }

  function depo(anahtar, deger) {
    try {
      if (deger === undefined) return window.localStorage.getItem(anahtar);
      window.localStorage.setItem(anahtar, deger);
    } catch (e) {}
    return null;
  }

  class NaarKuponMerkezi extends HTMLElement {
    connectedCallback() {
      if (this._hazir) return;
      this._hazir = true;
      this.fark = Number(this.dataset.simdi) * 1000 - Date.now();
      var demo = this.dataset.onizleme === 'true' ? new URLSearchParams(location.search).get('kupon_demo') : null;
      this.demo = ['acik', 'bekliyor', 'tukendi', 'bitti'].indexOf(demo) > -1 ? demo : null;
      this.biletler = Array.prototype.slice.call(this.querySelectorAll('[data-nkm-bilet]'));

      if (this.demo) this.demoUygula();
      this.biletler.forEach(function (b) {
        b.addEventListener('click', this.tikla.bind(this, b));
      }, this);
      this.kayitliKodlariGoster();
      this.guncelle();
      this.zamanlayici = setInterval(this.guncelle.bind(this), 1000);
    }

    disconnectedCallback() { clearInterval(this.zamanlayici); }

    simdi() { return (Date.now() + this.fark) / 1000; }

    demoUygula() {
      var simdi = this.simdi();
      this.biletler.forEach(function (b) {
        b.dataset.durum = this.demo;
        if (this.demo === 'bekliyor') b.dataset.hedef = String(Math.floor(simdi + 3 * 3600 + 14 * 60 + 9));
      }, this);
    }

    /* durum satırı: etiket + (yalnız bekleyenlerde) geri sayım ayrı parçalar */
    yaz(b, etiket, sure) {
      var e = b.querySelector('[data-nkm-etiket]');
      var s = b.querySelector('[data-nkm-sure]');
      if (e && e.textContent !== etiket) e.textContent = etiket;
      if (s && s.textContent !== (sure || '')) s.textContent = sure || '';
    }

    metin(b, durum) {
      var dugme = b.querySelector('[data-nkm-dugme]');
      var hedef = Number(b.dataset.hedef);
      var m, d, kapali = true, sure = '';
      var kutu = b.querySelector('[data-nkm-kod]');
      if (kutu && !kutu.hidden) {
        if (durum === 'acik') return; /* kod gösteriliyor: metni ve düğmeyi ezme */
        kutu.hidden = true; /* kupon bitti/tükendi: eski kodu gizle */
        if (dugme) dugme.hidden = false;
      }
      if (durum === 'acik') { m = b.dataset.acikMetin || 'Şimdi açık'; d = 'Kullan'; kapali = false; }
      else if (durum === 'tukendi') { m = 'Kuponlar tükendi'; d = 'Tükendi'; }
      else if (durum === 'bitti') { m = 'Süresi doldu'; d = 'Sona erdi'; }
      else { m = b.dataset.etiket || 'Yakında'; sure = sureYaz(hedef - this.simdi()); d = this.dataset.uygulaYonlen ? 'Yakında' : 'Henüz açılmadı'; }
      this.yaz(b, m, sure);
      if (dugme) {
        if (dugme.textContent !== d) dugme.textContent = d;
        dugme.disabled = kapali;
      }
    }

    guncelle() {
      var simdi = this.simdi();
      var yenile = false;
      this.biletler.forEach(function (b) {
        var durum = b.dataset.durum;
        var hedef = Number(b.dataset.hedef);
        if (!this.demo) {
          if (durum === 'bekliyor' && hedef && simdi >= hedef) yenile = true;
          if (durum === 'acik' && simdi > Number(b.dataset.bitis)) yenile = true;
        }
        this.metin(b, durum);
      }, this);
      if (yenile) this.yenile();
    }

    /* Geri sayım bitti ya da kupon süresi doldu: durumları sunucudan al. Henüz değişmediyse üç saniye sonra tekrar dener. */
    yenile() {
      if (this._yenileniyor) return;
      this._yenileniyor = true;
      var self = this;
      this.uctanAl(false).then(function (veri) {
        if (!veri || !veri.kuponlar) return;
        self.fark = Number(veri.simdi) * 1000 - Date.now();
        self.biletler.forEach(function (b) {
          var k = self.bul(veri, b.dataset.anahtar);
          if (!k) { b.dataset.durum = 'bitti'; b.dataset.hedef = '0'; }
          else { b.dataset.durum = k.durum; b.dataset.hedef = String(k.hedef); b.dataset.bitis = String(k.bitis); }
          self.metin(b, b.dataset.durum);
        });
      }).catch(function () {}).then(function () {
        setTimeout(function () { self._yenileniyor = false; }, 3000);
      });
    }

    bul(veri, anahtar) {
      var liste = (veri && veri.kuponlar) || [];
      for (var i = 0; i < liste.length; i++) if (liste[i].h === anahtar) return liste[i];
      return null;
    }

    uctanAl(demo) {
      var url = (demo || this.demo ? this.dataset.ucDemo : this.dataset.uc) + '&t=' + Date.now();
      return fetch(url, { cache: 'no-store', credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (t) {
        try { return JSON.parse(t); } catch (e) { return null; }
      });
    }

    tikla(b, olay) {
      var dugme = olay.target.closest('[data-nkm-dugme]');
      var kopya = olay.target.closest('[data-nkm-kopya]');
      if (kopya) { this.kopyala(b, kopya); return; }
      if (!dugme || dugme.disabled) return;
      this.kodAl(b, dugme);
    }

    kodAl(b, dugme) {
      var self = this;
      var onceki = dugme.textContent;
      dugme.disabled = true;
      dugme.textContent = 'Kod getiriliyor…';
      this.uctanAl(!!this.demo).then(function (veri) {
        var k = self.bul(veri, b.dataset.anahtar);
        if (k) { b.dataset.durum = k.durum; b.dataset.hedef = String(k.hedef); b.dataset.bitis = String(k.bitis); }
        else if (veri) { b.dataset.durum = 'bitti'; b.dataset.hedef = '0'; }
        if (k && k.durum === 'acik' && k.kod) {
          self.kodGoster(b, k.kod);
          var kb = b.querySelector('[data-nkm-kopya]'); if (kb) self.kopyala(b, kb);
          if (!self.demo) depo(self.anahtar(b), k.kod);
        } else {
          self.metin(b, b.dataset.durum);
          if (b.dataset.durum === 'acik') self.yaz(b, 'Kupon şu an alınamıyor, birazdan tekrar deneyin.');
        }
      }).catch(function () {
        self.yaz(b, 'Bağlantı hatası, tekrar deneyin.');
        dugme.textContent = onceki;
        dugme.disabled = false;
      });
    }

    anahtar(b) { return 'naar-kupon-' + b.dataset.anahtar; }

    kayitliKodlariGoster() {
      if (this.demo) return;
      this.biletler.forEach(function (b) {
        var kod = depo(this.anahtar(b));
        if (kod && b.dataset.durum === 'acik') this.kodGoster(b, kod);
      }, this);
    }

    kodGoster(b, kod) {
      var kutu = b.querySelector('[data-nkm-kod]');
      var deger = b.querySelector('[data-nkm-kod-deger]');
      var uygula = b.querySelector('[data-nkm-uygula]');
      var dugme = b.querySelector('[data-nkm-dugme]');
      if (!kutu || !deger) return;
      deger.textContent = kod;
      var yonlen = this.dataset.uygulaYonlen;
      if (uygula) uygula.href = '/discount/' + encodeURIComponent(kod) + '?redirect=' + encodeURIComponent(yonlen || '/cart');
      /* Ürün sayfası: kod arka planda uygulanır (ödeme adımında kendiliğinden düşer); hata sessizce yutulur, kod zaten görünür. */
      if (yonlen && !this.demo) fetch('/discount/' + encodeURIComponent(kod) + '?redirect=' + encodeURIComponent(yonlen), { credentials: 'same-origin' }).catch(function () {});
      kutu.hidden = false;
      if (dugme) dugme.hidden = true;
      this.yaz(b, 'Kuponunuz hazır');
    }

    kopyala(b, dugme) {
      var kod = (b.querySelector('[data-nkm-kod-deger]') || {}).textContent || '';
      if (!kod) return;
      var bu = this;
      var bitti = function () {
        bu.yaz(b, 'Kuponunuz hazır');
        var ikon = dugme.hasAttribute('data-ikon');
        if (!ikon) dugme.textContent = 'Kopyalandı';
        dugme.setAttribute('data-kopyalandi', '');
        setTimeout(function () { if (!ikon) dugme.textContent = 'Kopyala'; dugme.removeAttribute('data-kopyalandi'); }, 2200);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(kod).then(bitti).catch(function () { yedek(); });
      } else { yedek(); }
      function yedek() {
        var a = document.createElement('textarea');
        a.value = kod; a.setAttribute('readonly', ''); a.style.position = 'fixed'; a.style.opacity = '0';
        document.body.appendChild(a); a.select();
        try { document.execCommand('copy'); bitti(); } catch (e) {}
        document.body.removeChild(a);
      }
    }
  }

  customElements.define('naar-kupon-merkezi', NaarKuponMerkezi);
})();
